import React from 'react'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { TextField, Button } from '@mui/material';

import AirRoundedIcon from '@mui/icons-material/AirRounded';
import ThermostatRoundedIcon from '@mui/icons-material/ThermostatRounded';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import GrainRoundedIcon from '@mui/icons-material/GrainRounded';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import OpacityRoundedIcon from '@mui/icons-material/OpacityRounded';

import Title from './Title'

export default function WeatherModal(props) {
  
  const weather = props.weather



  if (!weather) {
    return (
      <></>
    )
  }

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="container">
          <div className="row">
            <div className='col-6'>
              <Title title={getHour(weather.dt)} />
            </div>
            <div className="col-6" style={{textAlign:'center'}}>
              {weather.weather[0].main}
              <img src={'https://openweathermap.org/img/wn/' + weather.weather[0].icon + '@2x.png'} alt='weather icon' style={{height:'55px'}}/>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-7">
            Descrizione
          </div>
          <div className="col-5">
            {weather.weather[0].description}
          </div><hr style={{width:'50%', marginRight:'auto', marginLeft:'auto'}}/>
          <div className="col-7">
            Temperatura
          </div>
          <div className="col-5">
            <ThermostatRoundedIcon />
            {weather.temp}°C
          </div>
          <div className="col-7">
            Temp Percepita
          </div>
          <div className="col-5">
            <ThermostatRoundedIcon />
            {weather.feels_like}°C
          </div><hr style={{width:'50%', marginRight:'auto', marginLeft:'auto'}}/>
          <div className="col-7">
            Precipitazioni
          </div>
          <div className="col-5">
            <GrainRoundedIcon />
            {weather.pop * 100} %
          </div>
          {
            weather.rain ? 
              <>
                <div className="col-7">
                  Volume Prec
                </div>
                <div className="col-5">
                  <GrainRoundedIcon />
                  {weather.rain['1h']}
                </div>
              </>
              :
              <></>
          }
          {
            weather.snow ? 
              <>
                <div className="col-7">
                  Volume Neve
                </div>
                <div className="col-5">
                  <AcUnitRoundedIcon />
                  {weather.snow['1h']}
                </div><hr style={{width:'50%', marginRight:'auto', marginLeft:'auto'}}/>
              </>
              :
              <></>
          }
          <div className="col-7">
            Velocità vento
          </div>
          <div className="col-5">
            <AirRoundedIcon />
            {weather.wind_speed} m/s
          </div>
          <div className="col-7">
            Direzione vento
          </div>
          <div className="col-5">
            <AirRoundedIcon />
            {weather.wind_deg} °
          </div><hr style={{width:'50%', marginRight:'auto', marginLeft:'auto'}}/>
          <div className="col-7">
            Umidità
          </div>
          <div className="col-5">
            <OpacityRoundedIcon />
            {weather.humidity} %
          </div><hr style={{width:'50%', marginRight:'auto', marginLeft:'auto'}}/>
          <div className="col-7">
            Visibilità
          </div>
          <div className="col-5">
            <RemoveRedEyeRoundedIcon />
            {weather.visibility} m
          </div>
        </div>
      </Box>
    </Modal>
  )
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight:'90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '20px'
};

function getHour(dateUTC)
{
  let d = new Date(dateUTC * 1000)
  return d.getHours().toString().padStart(2, '0') + ':' +d.getMinutes().toString().padStart(2, '0')
}